/**
 * get the path link, optionally ignoring fragments
 * @param path the path to get the link for
 * @param ignoreFragments whether to ignore fragments
 * @returns the path link
 */
export const getPathLink = (path = '', ignoreFragments) => {
    if (!path) {
        return '';
    }
    return ignoreFragments ? path.split('#')[0] : path;
};
//# sourceMappingURL=side_nav_link.utils.js.map